import { render, staticRenderFns } from "./reserveImgTableCont.vue?vue&type=template&id=5287a0f0"
import script from "./reserveImgTableCont.vue?vue&type=script&lang=js"
export * from "./reserveImgTableCont.vue?vue&type=script&lang=js"
import style0 from "./reserveImgTableCont.vue?vue&type=style&index=0&id=5287a0f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports